import React from 'react'
import { PropTypes } from 'prop-types'
import SanityImage from 'gatsby-plugin-sanity-image'
import PortableText from '../portableText'
import CTALink from '../CTALink'
import { GridColumn, GridMedia, GridContent, GridLink, GridCallOutText } from './Grid.styles'

export default function Column({ title, callOutText, text, illustration, image, cta, border, center }) {
	return (
		<GridColumn border={border}>
			{callOutText ? <GridCallOutText>{callOutText}</GridCallOutText> : null}
			{illustration ? (
				<>
					{illustration.image.asset ? (
						<GridMedia>
							<SanityImage
								asset={illustration.image.asset}
								alt={illustration.image.alt}
								width={500}
								{...illustration}
							/>
						</GridMedia>
					) : null}
				</>
			) : null}
			{image ? (
				<>
					{image.asset ? (
						<GridMedia>
							<SanityImage asset={image.asset} alt={image.alt} {...image} />
						</GridMedia>
					) : null}
				</>
			) : null}
			<GridContent center={center}>
				{text && <PortableText blocks={text} />}
				{cta && cta.title && (
					<GridLink>
						<CTALink {...cta} />
					</GridLink>
				)}
			</GridContent>
		</GridColumn>
	)
}

Column.propTypes = {
	title: PropTypes.string,
	callOutText: PropTypes.string,
	text: PropTypes.array,
	illustration: PropTypes.object,
	cta: PropTypes.object,
	border: PropTypes.bool,
	center: PropTypes.bool,
}
